"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretDoubleDown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CaretDoubleDown = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("polyline", { points: "208 128 128 208 48 128", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" }), (0, jsx_runtime_1.jsx)("polyline", { points: "208 48 128 128 48 48", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" })] })));
};
exports.CaretDoubleDown = CaretDoubleDown;
